import Iconify from 'src/components/Iconify';
import { resolvePlatform } from 'src/design/tokens';
import { MKT } from '../marketing.design';

// Fonte unica de icone/label/cor de plataforma na secao Marketing. Antes
// disso havia 3 mapas COLORS locais nas abas de Analytics (com Instagram em
// dois hexs diferentes) e um par de funcoes redefinidas a cada render em
// Rastreamento — ver resolvePlatform em src/design/tokens.js.
export default function PlatformChip({ platform, size = 'base', className = '' }) {
    const info = resolvePlatform(platform);
    if (!info) return null;

    const chipClass = size === 'sm' ? MKT.chip.sm : MKT.chip.base;
    const toneClass = MKT.tone[info.tone] ?? MKT.tone.neutral;

    return (
        <span className={`${chipClass} ${toneClass} ${className}`}>
            <Iconify icon={info.icon} width={size === 'sm' ? 12 : 14} style={{ color: info.color }} />
            {info.label}
        </span>
    );
}
